import * as types from "../ActionType";

const initState = {
    users: [],
    loadingUsers: true,
    user_id: null
}

const AuthReducer = (state = initState, action) => {
    switch (action.type) {
        case types.LOGIN_ADMIN:
            return { ...state }
        case types.LOGOUT_ADMIN:
            return { ...state }
        case types.GET_USERS:
            return { ...state, users: action.payload, loadingUsers: false }
        case types.SEND_NOTIFICATIONS:
            return { ...state }
        case types.SET_USER_ID:
            return { ...state,user_id: null }
        default:
            return state;
    }
};

export default AuthReducer;
